import { TranslationObject } from '@ngx-translate/core';

const fr: TranslationObject = {
  fr: 'Français',
  en: 'Anglais',
  app: {
    title: 'Revue de sécurité pré-démarrage',
    forms: {
      ok: 'Ok',
      cancel: 'Annuler',
      create: 'Créer',
      continue: 'Continuer',
      selectAll: 'Tout Sélectionner',
      save: 'Enregistrer',
      labels: {
        businessUnit: 'Unité d\'affaires',
        organization: 'Organisation',
        user: 'Utilisateur',
        name: 'Nom',
        description: 'Description',
        displayRichEditor: 'Afficher l\'éditeur riche',
        statusOptions: {
          draft: 'Draft',
          initiated: 'Initiated',
          inProgress: 'In Progress',
          completed: 'Completed',
          pendingApproval: 'Pending Approval',
          approved: 'Approved',
          closed: 'Closed',
        },
        placeHolderDescription: 'Entrez une description',
        placeHolderReviewType: 'Sélectionnez un type de revue',
        mandatory: 'Obligatoire',
        isActive: 'Actif',
      },
      categories: {
        placeholders: {
          categoryName: 'Nom de la catégorie',
        },
      },
      unsavedChangesWarning:
        'Des modifications non enregistrées ont été détectées. Si vous quittez cette page, les modifications que vous avez apportées seront perdues.<br>Voulez-vous continuer?',
      validation: {
        required: '{{controlName}} est obligatoire',
        invalidEmail: 'Veuillez saisir une adresse e-mail valide',
      },
    },
    warnings: {
      removeOwnAdminRights:
        'Vous avez supprimé vos droits d\'administrateur. Veuillez actualiser la page web pour éviter tout dysfonctionnement.',
      removeOwnAccess:
        'Vous avez supprimé votre accès. Veuillez actualiser la page web pour éviter tout dysfonctionnement.',
    },
  },
  header: {
    support: 'Support',
    userGuide: 'Guide de l\'utilisateur',
  },
  navigation: {
    pssrs: '{{pssrTitle}}s',
    projects: 'Projets',
    actionsItems: 'Éléments d\'action',
    administration: 'Administration',
    hierarchyManagement: 'Gestion de la hiérarchie',
    businessUnits: 'Unités d\'affaires',
    organizations: 'Organisations',
    facilityHierarchy: 'Hiérarchie d\'installation',
    accessManagement: 'Gestion de l\'accès',
    organizationUsers: 'Utilisateurs',
    buAdmins: 'Administrateurs des utilisateurs',
    userGroups: 'Groupes d´utilisateurs d´actions',
    systemAdmins: 'Administrateurs système',
    pssrConfiguration: 'Configuration PSSR',
    templates: 'Listes de contrôle PSSR',
    categories: 'Catégories d\'unité d\'affaires',
  },
  functionalReviewList: {
    title: 'Revue Fonctionnelle',
    noFunctionalReview: 'Aucune revue fonctionnelle',
    id: 'ID',
    code: 'Code',
    question: 'Question',
    answer: 'Réponse',
    comment: 'Commentaire',
    updatedBy: 'Mis à jour par',
    updatedDate: 'Date de mise à jour',
    createNewFunctionalReview: 'créer une nouvelle revue fonctionnelle',
    reviewType: 'Type de revue',
    addQuestion: 'Ajouter une Question',
    description: 'Description',
    subSection: 'Sous-section',
    clearAnswer: 'Effacer la Réponse',
    deleteQuestion: 'Supprimer la Question',
    deleteQuestionTitle: 'Supprimer la Question',
    confirmDeleteQuestion:
      '<span>Êtes-vous sûr de vouloir supprimer cette question?</span><br><br><span><b>Question:</b> {{ description }}</span>',
    generateReport: 'Générer le Rapport',
    completeReview: 'Terminer la Revue',
    generateSuccessMessage: 'Rapport généré avec succès',
    reviewSuccessMessage: 'Revue fonctionnelle terminée avec succès',
  },
  admin: {
    sysAdminList: {
      title: 'Administrateurs Système',
      addSysAdmin: 'ajouter un administrateur système',
      fullName: 'nom complet',
      disabled: 'Désactivé',
      email: 'email',
      dialogs: {
        removeAccessHeader: 'Confirmation',
        removeAccessMessage:
          'Êtes-vous sûr de vouloir supprimer l\'accès administrateur système pour : [{{firstName}} {{lastName}}]?',
      },
    },
    businessUnitLists: {
      title: 'Unités d\'affaires',
      addBusinessUnit: 'ajouter une unité d\'affaires',
      tableTitle: 'Unité d\'affaires',
    },
    businessUnitCreate: {
      title: 'Créer une unité d\'affaires',
    },
    businessUnitEdit: {
      title: 'Modifier l\'unité d\'affaires',
    },
    businessUnitForm: {
      sections: {
        supportInformation: {
          titleSupport: 'Informations de Support',
          name: 'Nom',
          businessUnitSupportInfo: 'Informations de Support de l\'Unité d\'Affaires',
          businessUnitSupportInfoDescription: 'Ces informations seront affichées sur la page de support',
          displayRichEditor: 'afficher l\'éditeur enrichi',
        },
        approvalForAccess: {
          titleApproval: 'Approbation pour l\'Accès',
          userNeedsBuAdmin: 'L\'utilisateur a besoin qu\'un administrateur de l\'unité d\'affaires lui accorde l\'accès',
          userGetsInstantAccess: 'L\'utilisateur obtiendra un accès instantané',
        },
        labels: {
          titleLabels: 'Étiquettes',
          hierarchyLabel1: 'Étiquette de Hiérarchie 1',
          hierarchyLabel2: 'Étiquette de Hiérarchie 2',
          hierarchyLabel3: 'Étiquette de Hiérarchie 3',
          pssrLabel: 'Étiquette PSSR',
          organizationLabel: 'Étiquette d\'Organisation',
          eventNameLabel: 'Étiquette de Nom d\'Événement',
          p3: 'P3',
          p4: 'P4',
          p5: 'P5',
          placeholderDefault: 'la valeur par défaut est \'projet\'',
          show: 'afficher',
        },
        pssrConfigurations: {
          titleConfigurations: 'Configurations PSSR',
          stagnantPssrInterval: 'Intervalle PSSR Stagnant',
          instructions: 'Instructions',
          instructionsDescription: 'Instructions générales stagnantes pour PSSR',
          showProject: 'Voulez-vous afficher Projet?',
          projectDisplayType: 'Comment souhaitez-vous afficher Projet?',
          dropdown: 'liste déroulante',
          input: 'entrée',
          showKms:
            'Voulez-vous afficher KMS? Un bouton "obtenir de KMS" sera affiché lors de la création d\'un nouveau PSSR.',
          showQaqcModule: 'Voulez-vous afficher le Module QAQC sur le Projet? Nécessite que le projet soit activé.',
          showWetSignatureApproval:
            'Voulez-vous permettre une signature humide du PSSR? Cela permet au Représentant des Opérations d\'approuver le PSSR en état d\'approbation en attente. Le bouton dit "approuver avec signature humide".',
          pssrTypesToShow: 'Quels Types PSSR voulez-vous afficher?',
          ccc: 'CCC',
          factory: 'Usine',
          moc: 'MOC',
          nonMoc: 'NON-MOC',
          orr: 'ORR',
          pfsr: 'PFSR',
          test: 'Test',
          showNaResponse:
            'Voulez-vous permettre aux utilisateurs de répondre N/A? Si vous sélectionnez non, un commentaire ou un élément d\'action sera requis pour être considéré comme terminé.',
          sendScheduledEmail:
            'Voulez-vous envoyer un e-mail programmé chaque lundi à 8h00 CST aux utilisateurs avec des éléments d\'action en attente?',
          showConstructionComplete:
            'Voulez-vous afficher le Certificat de Construction Complète (CCC) pour certains en-têtes/titres/étiquettes?',
          showOperationReadiness:
            'Voulez-vous afficher la Revue de Préparation Opérationnelle (ORR) pour certains en-têtes/titres/étiquettes?',
          showVerbalApproval:
            'Voulez-vous afficher l\'approbation verbale? Cela montre une entrée dans l\'application mobile pour écrire manuellement qui approuve. Cela ne provoque aucune action et peut être effectué par le responsable ou l\'approbateur.',
          allowLeadToDelete:
            'Voulez-vous permettre au responsable de supprimer des questions pour un PSSR en état de brouillon ou lancé?',
          allowTeamMemberActions:
            'Voulez-vous permettre à n\'importe quel membre de l\'équipe de répondre aux questions, signer les questions et créer des éléments d\'action jusqu\'à l\'approbation?',
          restrictMocWo:
            'Voulez-vous restreindre le numéro de projet MOCWO? Si vous sélectionnez "oui", MOC et WO sont requis pour créer un PSSR.',
          allowLeadsToShare:
            'Voulez-vous permettre aux Responsables de partager l\'appareil avec les approbateurs? Si vous sélectionnez "oui", le responsable peut partager l\'appareil avec l\'approbateur si l\'approbateur est présent pour signer.',
          requireFinalApprovalBeforeInitiation:
            'Voulez-vous exiger une approbation finale avant l\'initiation? Si "oui", le PSSR devra avoir un approbateur final pour le lancer.',
          allowFinalApproverNotifications:
            'Voulez-vous permettre à l\'approbateur final de recevoir toutes les notifications?',
          allowFinalApproverSubmit: 'Voulez-vous permettre à l\'approbateur final de soumettre pour approbation?',
          allowMultiplesApprovers: 'Voulez-vous permettre plusieurs approbateurs?',
          ShowSectionsCollapsed: 'Voulez-vous réduire les sections PSSR lors de l\'édition?',
          requireActionItemDueDate: 'Voulez-vous exiger une date d\'échéance pour les éléments d\'action?',
          limitAccessToAIOwner:
            'Voulez-vous restreindre le propriétaire ou l\'assigné de l\'élément d\'action de modifier la description, changer la date d\'échéance ou supprimer l\'élément d\'action?',
        },
        actionItemConfigurations: {
          titleItemConfigurations: 'Configurations des Éléments d\'Action',
          sendToMoc: 'Voulez-vous envoyer des éléments d\'action à MOC?',
          p3: 'P3',
          p4: 'P4',
          allowTeamLeadAttach:
            'Voulez-vous permettre au chef d\'équipe de joindre et modifier un élément d\'action? Si vous sélectionnez "oui", les responsables ne peuvent joindre que des fichiers, assigné, état et commentaire après approbation en attente.',
          allowActionItemOwnerAttach:
            'Voulez-vous permettre au propriétaire de l\'élément d\'action de joindre dans n\'importe quel état tant que le PSSR n\'est pas fermé?',
        },
      },
    },
  },
  user: {
    requestAccess: {
      title: 'Non enregistré',
      forms: {
        submit: 'Demander l\'accès',
      },
      dialogTitle: 'Demander l\'accès',
      dialogSubtitle:
        'Vous êtes sur le point de demander l\'accès pour <strong>{{Name}}</strong>, voulez-vous continuer?',
      reloadWarning:
        'Si vous consultez cette page mais avez déjà accès, veuillez cliquer sur le lien suivant pour recharger, sinon contactez le support.',
      reload: 'Recharger',
    },
    pendingAccess: {
      title: 'Bonjour, votre demande d\'accès est en cours',
      reloadWarning:
        'Si vous consultez cette page mais avez déjà accès, veuillez cliquer sur le lien suivant pour recharger, sinon contactez le support.',
      reload: 'Recharger',
    },
  },
  footer: {
    text: 'Chevron Corporation. Tous droits réservés.',
  },
  checklist: {
    title: 'Liste de Contrôle PSSR',
    create: 'créer nouveau',
    hideCode: 'masquer le code',
    code: 'Code',
    name: 'Nom de la liste de contrôle',
    emptyHierarchyChildrenMessage:
      '<p>Aucun(e) <strong>{{childLabel}}</strong> n\'est disponible pour ce(tte) <strong>{{parentLabel}}</strong>.</p><p>Veuillez ajouter un(e) nouveau(elle) <strong>{{childLabel}}</strong> pour commencer.</p>',
    edit: 'modifier',
    manage: 'gérer',
    delete: 'supprimer',
    defaultWalkthroughDisclaimer: 'Clause de non-responsabilité de signature de procédure par défaut',
    defaultSummaryDisclaimer: 'Clause de non-responsabilité de signature de résumé par défaut',
    displayRichEditor: 'afficher l\'éditeur enrichi',
    sampleText: 'exemple de texte',
    dialogs: {
      removeAccessHeader: 'Confirmation',
      removeAccessMessage: 'Êtes-vous sûr de vouloir supprimer [{{description}}] ?',
    },
    confirmDelete:
      '<span>Êtes-vous sûr de vouloir supprimer cette liste de contrôle ?</span><br><br><span>Nom : {{ name }}<br>Description : {{ description }}</span>',
    noChecklists: 'Aucune liste available.',
    titleCreate: 'Créer une liste de contrôle',
    createNew: 'Créer une nouvelle',
    selectPlaceholder: 'Choisissez-en un...',
    titleEdit: 'Liste de vérification de modification',
    titleDelete: 'Supprimer la liste de contrôle',
    deletedSuccessfully: 'Liste de contrôle supprimée avec succès',
    importChecklist: 'Importer la liste de contrôle',
    importChecklistTitle: 'Importer la liste de contrôle dans ',
    selectChecklistType: 'Sélectionner le type de liste de contrôle',
    confirm: 'Confirmer',
    importSuccessMessage: 'Liste de contrôle importée avec succès',
  },
  common: {
    yes: 'Oui',
    no: 'Non',
    na: 'N/A',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    businessUnit: 'Unité commerciale',
    forbidActionErrorMessage: ' L\'utilisateur n\'est pas autorisé à effectuer cette action.',
    name: 'Nom',
    code: 'Code',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    back: 'Retour',
    genericErrorMessage: 'Une erreur inattendue est survenue. Veuillez réessayer plus tard.',
    errorOccurred: 'Une erreur s\'est produite. Veuillez réessayer.',
    savedSuccessfully: 'Enregistré avec succès',
    createdSuccessfully: 'Créé avec succès',
    delete: 'Supprimer',
    deletedSuccessfully: 'Supprimé avec succès',
    edit: 'Modifier',
    leaveWithOutSaving: 'Quitter sans enregistrer',
    language: 'Langue',
    month: 'Mois',
    months: 'Mois',
    loading: 'Chargement...',
    all: 'Tous',
    recordAlreadyExists: 'L enregistrement existe déjà',
    recordCreatedSuccessfully: 'Enregistrement créé avec succès',
  },
  checklistManage: {
    title: 'Gérer le contenu de [{{ description }}]',
    sectionsTitle: 'Sections',
    addSectionAction: 'ajouter une section',
    mandatoryLabel: 'Obligatoire',
    createNewSubsectionAction: 'Créer une nouvelle sous-section',
    emptySubSectionsMessage:
      '<p>Il n\'y a aucun contenu disponible pour cette section.</p><p>Veuillez ajouter une sous-section pour commencer.</p>',
    itemCodeTableHeader: 'code',
    itemDescriptionTableHeader: 'Description',
    createNewItemAction: 'Ajouter une question',
    createSectionHeader: 'Créer une section',
    editSectionHeader: 'Modifier la section',
    confirmDeleteSection: 'Êtes-vous sûr de vouloir supprimer la section <strong>{{description}}</strong> ?',
    createSubSectionHeader: 'Créer une sous-section',
    editSubSectionHeader: 'Modifier la sous-section',
    createChecklistItemTitle: 'Créer un élément de liste de contrôle',
    editChecklistItemTitle: 'Modifier l\'élément de la liste de contrôle',
    ShouldAddCommentToQuestion:
      'L utilisateur doit ajouter un commentaire à toute question à laquelle la réponse est N/ A',
    autoGenerateCodeLabel: 'Générer automatiquement le code',
    autoGenerateCodeplaceholder: 'Le code sera généré automatiquement',
    autoGenerateCodeInfo: 'La génération automatique a été activée, le champ sera automatiquement rempli.',
    deleteChecklistItemTitle: 'Supprimer l\'élément de la liste de contrôle',
    confirmDeleteChecklistItem:
      '<span>Êtes-vous sûr de vouloir supprimer cet élément de la liste de contrôle ?</span><br><br><span><b>Code :</b> {{ name }}<br><b>Description :</b> {{ description }}</span>',
    confirmDeleteSubSection: 'Êtes-vous sûr de vouloir supprimer la sous-section <strong>{{description}}</strong> ?',
    deleteSectionHeader: 'Supprimer la section',
    deleteSubSectionHeader: 'Supprimer la sous-section',
    editQuestionTitle: 'Modifier la question',
    sectionTypeLabel: 'Type de section',
    sectionTypePlaceholder: 'Sélectionnez un type de section',
    subSectionNameLabel: 'Nom de la sous-section',
    itemTypeLabel: 'Type',
    itemTypePlaceholder: 'sélectionnez un',
    codePlaceholder: 'Entrez le code',
    duplicateCodeError: 'Ce code est déjà utilisé dans une autre section.',
    displayRichEditorLabel: 'Afficher l\'éditeur enrichi',
    requireCommentForNA: 'Voulez-vous exiger un commentaire pour une question N/A ?',
  },
  paginator: {
    previous: 'Précédent',
    next: 'Suivant',
    currentPageReport: '{{currentInitialRow}} - {{currentLastRow}} sur {{totalRecords}}',
  },
  usersList: {
    title: 'Utilisateurs',
    forms: {
      displayInactiveUsers: 'afficher les utilisateurs inactifs',
      search: 'Rechercher',
    },
    actions: {
      addNewUser: 'Ajouter un nouvel utilisateur',
      grantAccess: 'accorder l\'accès',
      reimportAllSharedUsers: 'Réimporter tous les utilisateurs partagés',
    },
    table: {
      fullName: 'nom complet',
      email: 'email',
      admin: 'admin',
      type: 'type',
    },
    noUsers: 'Aucun utilisateur disponible',
    dialogs: {
      removeAccessHeader: 'Confirmation',
      removeAccessMessage: 'Êtes-vous sûr de vouloir supprimer l\'accès pour : [{{fullName}}]?',
      addUserHeader: 'Ajouter un nouvel utilisateur',
      editUserHeader: 'Modifier l\'utilisateur',
      reimportSharedUsersHeader: 'Réimporter tous les utilisateurs partagés',
      reimportSharedUsersMessage:
        'Vous êtes sur le point de mettre à jour la configuration de tous les utilisateurs partagés.<br> Cette opération pourrait prendre plusieurs minutes.',
    },
    messages: {
      importSharedUsersFailed: 'L\'importation a échoué',
      importSharedUsersIncompleted: 'Importation incomplète',
      importSharedUsersCompleted: 'Importation complétée en: {{ minutes }} mins',
      pleaseWaitUntilProcessEnds:
        'Veuillez attendre la fin du processus d\'importation. Ne fermez pas cette page ni ne navigez pas ailleurs.',
      importInProgress: 'L\'importation est en cours. Veuillez attendre qu\'elle soit terminée avant de fermer la page.',
      calculatingProgress: 'Calcul de la progression...',
    },
    labels: {
      imported: 'Importés',
      notFound: 'Non trouvé',
      errors: 'Erreurs',
      total: 'Total',
    },
  },
  actionItems: {
    title: 'actions',
    addActionItem: 'Ajouter une action',
    noActionItems: 'Aucun élément d\'action disponible',
    canOnlyPerformAttachments:
      'Vous ne pouvez gérer que les pièces jointes. Les autres propriétés de l\'élément d\'action ne peuvent pas être modifiées.',
    actionTitle: 'Titre',
    assignee: 'Assigné',
    date: 'Date',
    dueDate: 'Date d\'échéance',
    category: 'Catégorie',
    primaryCategory: 'Catégorie principale',
    secondaryCategory: 'Catégorie secondaire',
    subcategory: 'Sous-catégorie',
    comment: 'Commentaire',
    editComment: 'Modifier le Commentaire',
    commentRequiredWhenClosed: 'Un commentaire est requis lorsque le statut est défini sur Fermé',
    id: 'ID',
    priority: 'Priorité',
    assignTo: 'Assigner à',
    pssrCccMembers: 'Membres {{pssrTitle}}',
    chevronDirectory: 'Répertoire Chevron',
    userGroup: 'Groupe d\'utilisateurs',
    other: 'Autre',
    status: 'Statut',
    statusNames: {
      Open: 'Ouvert',
      Closed: 'Fermé',
      Cancel: 'Annulé',
      Rejected: 'Rejeté',
    },
    createdBy: 'Créé par',
    updatedDate: 'Date de mise à jour',
    updatedBy: 'Mis à jour par',
    selectOne: 'Sélectionnez un...',
    typeNameOrEmail: 'Tapez nom ou e-mail...',
    inactive: 'Inactif',
    reopen: 'Rouvrir',
    reject: 'Rejeter',
    rejectReason: 'Raison du Rejet',
    rejectReasonPlaceholder: 'Entrer la raison du rejet',
    timeCaptured: 'Heure Capturée',
    attachments: 'Pièces jointes',
    pssrFiles: 'Fichiers PSSR',
    links: 'Liens',
    fileUpload: 'Téléchargement de fichiers',
    attachFiles: 'Joindre (docs, images, etc.)',
    fileTooLarge: 'Le fichier \'{{name}}\' dépasse la taille maximale autorisée de {{max}}.',
    invalidFileFormat: 'Le fichier \'{{name}}\' a un format non pris en charge.',
    duplicateFile: 'Le fichier \'{{name}}\' a déjà été ajouté.',
    linkPlaceholder: 'www.exemple.com',
    dialogs: {
      configureActionItem: 'Configurer l\'élément d\'action',
      configureComment: 'Commentaire',
      deleteActionItemHeader: 'Supprimer l\'élément d\'action',
      deleteActionItemMessage: 'Êtes-vous sûr de vouloir effectuer cette action?',
      rejectActionItemHeader: 'Rejeter l\'Élément d\'Action',
      confirmPriorityChangeHeader: 'Confirmer le Changement de Priorité',
      confirmPriorityChangeMessage: 'Êtes-vous sûr de vouloir modifier la priorité de cet élément d\'action?',
      deleteAttachmentHeader: 'Supprimer la Pièce Jointe',
      deleteAttachmentMessage: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe?',
    },
    messages: {
      deleteSuccess: 'Élément d\'action supprimé avec succès',
      reopenSuccess: 'Élément d\'action rouvert avec succès',
      rejectSuccess: 'Élément d\'action rejeté avec succès',
      rejectReasonRequired: 'La raison du rejet est requise',
      confirmReject: 'Êtes-vous sûr de vouloir rejeter cet élément d\'action? Il sera {{action}}.',
      confirmRejectP4: 'Êtes-vous sûr de vouloir rejeter cet élément d\'action?',
      returnToTeamLead: 'retourné au Chef d\'Équipe',
      confirmReopen: 'Êtes-vous sûr de vouloir rouvrir cet élément d\'action?',
    },
  },
  actionItemsList: {
    title: 'Éléments d\'Action',
    sections: {
      location: 'Emplacement',
      pssr: 'PSSR',
      actionItem: 'Élément d\'Action',
    },
    fields: {
      area: 'Zone',
      facilityOperationTeam: 'Équipe d\'Exploitation des Installations',
      facility: 'Installation',
      titleStatus: 'Statut du Titre',
      type: 'Type',
      title: 'Titre',
      project: 'Projet',
      template: 'Modèle',
      leadFinalApprover: 'Responsable/Approbateur Final',
      showOnlyDeletedPssr: 'Afficher Uniquement les PSSR Supprimés',
      status: 'Statut',
      priority: 'Priorité',
      assignedTo: 'Assigné à',
      autoLoadImages: 'Chargement Automatique des Images',
    },
    placeholders: {
      selectOne: 'sélectionner un',
      sampleText: 'texte d\'exemple',
      no: 'Sélectionner Non',
    },
    priorityDescriptions: {
      p3: 'L\'élément doit être complété avant le démarrage',
      p4: 'L\'élément sera complété après le démarrage',
      p5: 'L\'élément doit être complété avant le démarrage',
    },
    priorityLegend: {
      title: 'Priorités des Éléments d\'Action',
    },
    actions: {
      clearFilter: 'effacer le filtre',
      exportExcel: 'exporter excel',
      noDataToExport: 'Aucun élément d\'action à exporter',
    },
    imageAltText: 'Image d\'Élément d\'Action',
    pssrTeamLead: 'Chef d\'Équipe PSSR',
    finalApprover: 'Approbateur Final',
    subsection: 'Sous-section',
    code: 'Code',
    question: 'Question',
    answer: 'Réponse',
    noData: 'Aucun élément d\'action disponible',
    noDataFound: 'Aucun élément d\'action trouvé pour les filtres sélectionnés',
  },
  responseSignature: {
    signedBy: 'Signé Par',
    signedOn: 'Signé Le',
    name: 'Nom',
    dateCaptured: 'Date Capturée',
    sign: 'Signer',
    finalApproverLabel: 'Approbateur Final',
    dialogs: {
      deleteHeader: 'Supprimer la signature',
      deleteMessage: 'Vous êtes sur le point de supprimer la signature, veuillez sélectionner confirmer pour continuer',
      cancel: 'annuler',
      delete: 'supprimer',
    },
  },
  comments: {
    title: 'Commentaires',
    addComment: 'Ajouter un commentaire',
    dialogs: {
      configureComment: 'Commentaire',
      deleteCommentHeader: 'Effacer le commentaire',
      deleteCommentMessage: 'Êtes-vous sûr de vouloir effectuer cette action?',
    },
    comment: 'Commentaire',
  },
  userType: {
    Chevron: 'Chevron',
    External: 'Tiers (externe)',
    Shared: 'Partagé',
  },
  areas: {
    title: 'Zone',
    showDeletedItems: 'Afficher les éléments supprimés',
    areaListTitle: 'Liste des zones',
    createFacilityOperationTeam: 'Créer une nouvelle équipe d\'exploitation des installations',
    createFacility: 'Créer une nouvelle installation',
    restore: 'Restaurer',
    emptySubAreaMessage:
      '<p>Il n\'y a aucun contenu disponible pour cette zone.</p><p>Veuillez ajouter une nouvelle équipe d\'exploitation des installations pour commencer.</p>',
    emptyHierarchyChildrenMessage:
      '<p>Il n\'y a aucun(e) <strong>{{childLabel}}</strong> disponible pour ce(tte) <strong>{{parentLabel}}</strong>.</p><p>Veuillez ajouter un(e) nouveau(elle) <strong>{{childLabel}}</strong> pour commencer.</p>',
    emptyAreaMessage:
      '<p>Il n\'y a aucun contenu disponible pour cette unité d\'affaires.</p><p>Veuillez ajouter une nouvelle zone pour commencer.</p>',
    subareaTitle: 'Équipe d\'exploitation des installations',
    facilityTitle: 'Installation',
    removeConfirmationHeader: 'Confirmation',
    confirmDeleteArea: 'Êtes-vous sûr de vouloir supprimer la zone <strong>{{description}}</strong> ?',
    confirmDeleteSubarea:
      'Êtes-vous sûr de vouloir supprimer l\'équipe d\'exploitation des installations <strong>{{description}}</strong> ?',
    confirmDeleteFacility: 'Êtes-vous sûr de vouloir supprimer l\'installation <strong>{{description}}</strong> ?',
    restoredSuccessfully: 'Restauré avec succès',
  },
  pssrImport: {
    title: 'Importer MOC',
    sections: {
      import: 'Import',
    },
    forms: {
      labels: {
        application: 'Application',
        pssrId: 'ID',
        mocId: 'ID MOC',
        mocName: 'Nom MOC',
      },
      placeholders: {
        application: 'sélectionner une option',
        pssrId: 'Entrez l\'ID MOC',
        mocName: 'Rempli automatiquement depuis iMOC',
      },
      validation: {
        mocIdRequired: 'L\'ID MOC est obligatoire',
        applicationRequired: 'L\'application est obligatoire',
      },
    },
    actions: {
      add: 'Ajouter',
      addMoc: 'Ajouter MOC',
      importAll: 'Tout Importer',
      createPssr: 'créer PSSR',
      searchMoc: 'rechercher MOC',
      importMocCreatePssr: 'Importer MOC et créer PSSR',
    },
    table: {
      id: 'ID',
      pssrId: 'ID PSSR',
      name: 'Nom',
      status: 'Statut',
    },
    summary: {
      records: 'Enregistrements',
      imported: 'Importés',
      errors: 'Erreurs',
    },
    status: {
      pending: 'En attente',
      inProgress: 'En cours',
      imported: 'Importé',
      warning: 'Avertissement',
      error: 'Erreur',
    },
    messages: {
      alreadyInList: 'L\'ID PSSR est déjà dans la liste d\'import.',
      pssrNotFound: 'PSSR introuvable.',
    },
  },
  pssrCreate: {
    title: 'Créer PSSR',
    sections: {
      generalInformation: 'Informations Générales',
      location: 'Emplacement',
      details: 'Détails',
      instructions: 'Instructions',
    },
    forms: {
      labels: {
        title: 'Titre',
        moc: 'MOC',
        wo: 'WO',
        description: 'Description',
        area: 'Zone',
        facilityOperationTeam: 'Équipe d\'Opération de l\'Installation',
        facility: 'Installation',
        project: 'Projet',
        template: 'Modèle',
        type: 'Type',
        organization: 'Organisation',
        subArea: 'Sous-zone',
        includeProjectTeam: 'Inclure les membres de l\'équipe du projet',
      },
      placeholders: {
        title: 'exemple de texte',
        moc: 'exemple de texte',
        wo: 'exemple de texte',
        description: 'Entrer la description',
        area: 'sélectionner un',
        facilityOperationTeam: 'sélectionner un',
        facility: 'sélectionner un',
        project: 'sélectionner un',
        template: 'sélectionner un',
        type: 'sélectionner un',
        subArea: 'sélectionner un',
      },
      validation: {
        titleRequired: 'Le titre est requis',
        mocRequired: 'MOC est requis',
        woRequired: 'WO est requis',
        businessUnitRequired: 'L\'unité d\'affaires est requise',
        organizationRequired: 'L\'organisation est requise',
        areaRequired: 'La zone est requise',
        facilityOperationTeamRequired: 'L\'équipe d\'opération de l\'installation est requise',
        facilityRequired: 'L\'installation est requise',
        projectRequired: 'Le projet est requis',
        templateRequired: 'Le modèle est requis',
        typeRequired: 'Le type est requis',
        requiredFieldsMessage:
          'Remarque : Veuillez remplir les champs marqués comme obligatoires. Veuillez cliquer sur Enregistrer.',
      },
      templateChangeConfirmTitle: 'Changer le modèle',
      templateChangeConfirmMessage:
        'Le changement de modèle mettra à jour les sections du PSSR. Êtes-vous sûr de vouloir changer le modèle ?',
    },
    actions: {
      create: 'créer',
      pullFromKMS: 'Extraire de KMS',
    },
    successMessage: 'PSSR créé avec succès',
  },
  pssrKms: {
    title: 'PSSR depuis KMS',
    sections: {
      generalInformation: 'Informations Générales',
      pssrInformation: 'Informations PSSR',
      location: 'Emplacement',
      details: 'Détails',
    },
    kmsInstruction:
      'Recherchez un numéro MOC spécifique ou filtrez la liste par statut et taille de page pour importer des données depuis KMS.',
    searchMOCNumber: 'Rechercher Numéro MOC',
    mocPattern: 'ex., MOC-2024-123',
    invalidMOCFormat: 'Format MOC invalide. Exemple: MOC-2024-123',
    search: 'Rechercher',
    filterByStatus: 'Filtrer la Liste KMS par Statut',
    filterPageSize: 'Filtrer le Nombre d\'Éléments KMS retournés',
    selectFromList: 'Sélectionner depuis la Liste MOC KMS',
    selectKMSItems: 'Sélectionner des éléments KMS',
    createNew: 'Créer Nouveau',
    enterName: 'Entrer le nom',
    add: 'Ajouter',
    enterProjectNumber: 'Entrer le numéro de projet',
    selectQAQCEvent: 'Sélectionner événement QAQC',
    selectFromQAQC: 'Sélectionner depuis QAQC',
    milestones: 'Jalons',
    workOrders: 'Ordres de Travail',
    selectMilestone: 'Sélectionner jalon',
    selectWorkOrder: 'Sélectionner ordre de travail',
    milestoneWorkOrders: 'Ordres de Travail des Jalons',
    note: 'Note',
    fillRequiredFields: 'Veuillez remplir les champs marqués comme obligatoires',
    generatePSSRs: 'Générer PSSRs',
    successMessage: 'PSSR depuis KMS créé avec succès',
    multipleSuccessMessage: 'Plusieurs PSSRs depuis KMS créés avec succès',
    loadingKMSItemsError: 'Erreur lors du chargement des éléments KMS. Veuillez réessayer.',
    selectKMSItemsWarning: 'Veuillez sélectionner au moins un élément KMS',
    kmsStatus: {
      draft: 'Brouillon',
      processActivated: 'Processus Activé',
      reviewInProgress: 'Révision en Cours',
      implementationInProgressEdit: 'Implémentation en Cours Modifier',
      changeRequestApproved: 'Demande de Changement Approuvée',
      changeRequestDenied: 'Demande de Changement Refusée',
      implementationInProgress: 'Implémentation en Cours',
      readyToStartUp: 'Prêt à Démarrer',
      completed: 'Terminé',
      canceled: 'Annulé',
      onHold: 'En Attente',
    },
    businessUnit: 'Unité d\'Affaires',
    selectPlaceholder: 'Sélectionnez un',
  },
  pssrSubSections: {
    actions: {
      addQuestion: 'Ajouter une question',
    },
  },
  pssrDetails: {
    title: 'Détails du PSSR',
    pssrId: 'ID du PSSR',
    sections: {
      generalInformation: 'Informations Générales',
      location: 'Emplacement',
      details: 'Détails',
      sectionsTitle: 'Sections',
      actionItems: 'Actions',
      comments: 'Commentaires',
      enableCustomOrderForSections: 'Activer l\'ordre personnalisé des sections',
      sectionsLegendTitle: 'Légende des sections',
      hideCompletedQuestions: 'Masquer les questions terminées',
      saveSectionOrder: 'Enregistrer l\'ordre des sections',
      confirmRemoveSectionTitle: 'Supprimer la section',
      confirmRemoveSectionDescription: 'Etes-vous sur de vouloir supprimer {{description}}?',
      sectionNameLabel: 'Nom de la section',
      sectionNamePlaceholder: 'Entrez le nom de la section',
      editSectionName: 'Modifier le nom de la section',
      addMultipleSectionName: 'Ajouter une section multiple',
      validation: {
        sectionNameRequired: 'Le nom de la section est requis',
        sectionNameDuplicated: 'Une section avec ce nom existe déjà',
      },
      toast: {
        unableToCompleteOperation: 'Impossible de terminer l\'opération',
        saveCompletedTitle: 'Enregistrement terminé',
        sectionsSortedSuccessfully: 'Les sections ont été triées avec succès',
        loadSectionsError: 'Erreur lors du chargement des sections. Veuillez réessayer.',
        userAlreadyAdded: 'Utilisateur déjà ajouté à cette section',
        userAddedSuccessfully: 'Utilisateur ajouté avec succès',
        sectionAddedSuccessfully: 'Section ajoutée avec succès',
        sectionUpdatedSuccessfully: 'Section mise à jour avec succès',
      },
      selectLead: 'Sélectionner responsable',
      section1Title: 'Section 1',
      legend: {
        defaultQuestionLabel: 'question par défaut',
        defaultQuestionDescription: 'question à laquelle on peut répondre par oui, non ou n/a',
        optionalLabel: 'optionnel',
        optionalDescription: 'peut être ajouté manuellement au PSSR',
        multipleLabel: 'multiple',
        multipleDescription: 'optionnel mais peut être ajouté plusieurs fois au PSSR',
        mandatoryLabel: 'obligatoire',
      },
      instructions: 'Instructions',
      history: 'Historique des modifications PSSR',
      attachments: 'Pièces Jointes PSSR',
    },
    subsections: {
      actionItemNeeded: 'Remarque : Un élément d\'action est nécessaire pour compléter les questions.',
    },
    questions: {
      code: 'Code',
      question: 'Question',
      answer: 'Réponse',
      updatedBy: 'Mis à Jour Par',
      updatedDate: 'Date de Mise à Jour',
      clearAnswer: 'effacer la réponse',
      deleteQuestion: 'supprimer la question',
      answerUpdated: 'Réponse mise à jour avec succès',
      answerCleared: 'Réponse effacée avec succès',
      questionDeleted: 'Question supprimée avec succès',
      confirmDeleteTitle: 'Supprimer la Question',
      confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer cette question : {{question}} ?',
      validation: {
        actionItemIsNeeded: 'Un élément d\'action est nécessaire pour compléter la question',
        commentIsNeeded: 'Un commentaire est nécessaire pour compléter la question',
        signatureIsNeeded: 'Une signature est nécessaire pour compléter la question',
        responseIsNeeded: 'Une réponse est nécessaire pour compléter la question',
        actionItemsClosedOrCancelledNeeded:
          'Des éléments d\'action {{P3Label}} fermés ou annulés sont nécessaires pour compléter la question',
      },
    },
    forms: {
      labels: {
        title: 'Titre',
        moc: 'MOC',
        wo: 'WO',
        description: 'Description',
        area: 'Zone',
        facilityOperationTeam: 'Équipe d\'Opération de l\'Installation',
        facility: 'Installation',
        project: 'Projet',
        template: 'Modèle',
        type: 'Type',
      },
      placeholders: {
        title: 'exemple de texte',
        moc: 'exemple de texte',
        wo: 'exemple de texte',
        description: 'Entrer la description',
        area: 'sélectionner un',
        facilityOperationTeam: 'sélectionner un',
        facility: 'sélectionner un',
        project: 'sélectionner un',
        template: 'sélectionner un',
        type: 'sélectionner un',
      },
      validation: {
        titleRequired: 'Le titre est requis',
        businessUnitRequired: 'L\'unité d\'affaires est requise',
        organizationRequired: 'L\'organisation est requise',
        areaRequired: 'La zone est requise',
        facilityOperationTeamRequired: 'L\'équipe d\'opération de l\'installation est requise',
        facilityRequired: 'L\'installation est requise',
        templateRequired: 'Le modèle est requis',
        typeRequired: 'Le type est requis',
        requiredFieldsMessage:
          'Remarque : Veuillez remplir les champs marqués comme obligatoires. Veuillez cliquer sur Enregistrer.',
      },
      templateChangeConfirmTitle: 'Changer le modèle',
      templateChangeConfirmMessage:
        'Le changement de modèle mettra à jour les sections du PSSR. Êtes-vous sûr de vouloir changer le modèle ?',
    },
    actions: {
      save: 'enregistrer',
      saveGeneralInformation: 'enregistrer les informations générales',
      showFullHistory: 'afficher l\'historique complet',
      showLessHistory: 'afficher moins d\'historique',
      attachFile: 'Joindre un fichier (documents, images, dessins psi, etc.)',
      attachFileButton: 'joindre un fichier',
      printToPdf: 'imprimer en pdf',
      sendEmailReminder: 'envoyer un rappel par e-mail',
      importMocActionItems: 'importer les éléments d\'action moc',
      sendToMocStartup: 'envoyer à l\'enregistrement moc pour approbation de démarrage',
      returnToTeamLead: 'retourner au chef d\'équipe',
      start: 'démarrer pssr',
      reject: 'rejeter',
      delete: 'supprimer',
      restorePssr: 'restaurer pssr',
      reopen: 'rouvrir',
    },
    mocImportedHint: 'Ce PSSR a été importé. Vous ne pouvez pas modifier son identifiant',
    history: {
      reason: 'Motif',
      by: 'Par',
      draftCreated: 'Brouillon Créé Le',
      initiated: 'Initié Le',
      started: 'Démarré Le',
      completed: 'Terminé Le',
      pendingApproval: 'Approbation en Attente Le',
      verbalApproval: 'Approbation Verbale Le',
      approved: 'Approuvé Le',
      rejected: 'Rejeté Le',
      restored: 'Restauré Le',
      deleted: 'Supprimé Le',
      closed: 'Fermé Le',
    },
    successMessage: 'PSSR mis à jour avec succès',
    pdfDownloadSuccess: 'PDF téléchargé avec succès',
    pssrDeletedSuccess: 'PSSR supprimé avec succès',
    pssrReopenedSuccess: 'PSSR rouvert avec succès',
    statusChangedSuccess: 'Statut PSSR modifié avec succès',
    pssrRejectedSuccess: 'PSSR rejeté avec succès',
    pssrRestoredSuccess: 'PSSR restauré avec succès',
    importMOCActionsSuccess: 'Éléments d\'action MOC importés avec succès',
    sendToMOCSuccess: 'Téléchargé vers MOC avec succès',
    emailSentSuccess: 'Rappel par e-mail envoyé avec succès',
    importMOCActionsNone: 'Aucun élément d\'action MOC à importer',
    lastSent: 'Dernier Envoi',
    messages: {
      questionAdded: 'Question ajoutée avec succès',
    },
    dialogs: {
      addQuestion: {
        descriptionLabel: 'Description',
        descriptionPlaceholder: 'Entrez la description de la question',
        descriptionRequired: 'La description est requise',
      },
    },
    rejectDialog: {
      title: 'Rejeter PSSR',
      reasonLabel: 'Raison du Rejet',
      cancel: 'Annuler',
      confirm: 'Rejeter',
    },
    emailReminderDialog: {
      title: 'Envoyer un Rappel par E-mail',
      sendReminder: 'Envoyer un Rappel',
      sendMessage: 'Envoyer un Message Personnalisé',
      reminderInstructions:
        'Envoyer un rappel aux assignés pour tous les AIs ouverts. Lorsque le PSSR est en statut d\'approbation en attente, les Approbateurs recevront une notification.',
      messageInstructions: 'Envoyer un message par e-mail à tous les Participants du PSSR',
      enterText: 'Entrez votre message...',
      cancel: 'Annuler',
      confirm: 'Envoyer',
    },
    commentDialog: {
      title: 'Commentaire',
      commentLabel: 'Commentaire',
      commentPlaceholder: 'exemple de texte',
      createdBy: 'Créé par',
      updatedDate: 'Date de mise à jour',
      updatedBy: 'Mis à jour par',
      documents: 'Documents',
      delete: 'supprimer',
      cancel: 'annuler',
      save: 'enregistrer',
      successMessage: 'Commentaire mis à jour avec succès',
      confirmDeleteAttachment: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe?',
      confirmDeleteAttachmentHeader: 'Supprimer la pièce jointe',
      commentRequired: 'Le commentaire est requis',
      addComment: 'Ajouter un Commentaire',
      editComment: 'Modifier le Commentaire',
      confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce commentaire?',
      confirmDeleteHeader: 'Supprimer le Commentaire',
      commentAdded: 'Commentaire ajouté avec succès',
      commentUpdated: 'Commentaire mis à jour avec succès',
      commentDeleted: 'Commentaire supprimé avec succès',
    },
    confirmDeleteHeader: 'Confirmer la suppression',
    confirmDeleteMessage: 'Vous êtes sur le point de supprimer cet élément. Voulez-vous continuer?',
    confirmDeleteComment: 'Êtes-vous sûr de vouloir supprimer ce commentaire?',
    commentDeletedSuccess: 'Commentaire supprimé avec succès',
    changeStatusHeader: 'Confirmer le Changement de Statut',
    confirmChangeStatus: 'Voulez-vous changer le statut?',
    confirmReturnToTeamLead: 'Voulez-vous retourner ce PSSR au Chef d\'Équipe?',
    confirmRejectHeader: 'Confirmer le Rejet',
    confirmRejectMessage: 'Êtes-vous sûr de vouloir rejeter ce PSSR?',
    confirmReopenHeader: ' ',
    confirmReopenMessage: 'Êtes-vous sûr de vouloir rouvrir ce PSSR?',
    comments: {
      title: 'Commentaires',
      addComment: 'ajouter un commentaire',
      noComments: 'Aucun commentaire ajouté',
      by: 'par',
      on: 'le',
    },
    validation: {
      onlyPSSRTeamLeadcanInitiatePSSR: 'Seul le chef d\'équipe de PSSR peut initier le PSSR',
      requireFinalApproverBeforeInitiation: 'Si cochée, le PSSR nécessitera un approbateur final pour l\'initier',
      pssrMustAnswerAllQuestionsToCompleteWalkdown:
        'Répondez à toutes les questions et signatures pour compléter le PSSR',
      pssrMustHaveFinalApproverToCompleteWalkdown: 'PSSR doit avoir un approbateur final pour compléter la visite',
      onlyPSSRTeamLeadcanSubmitforPendingApproval:
        'Seul le chef d\'équipe de PSSR peut soumettre pour approbation en attente',
      p3ActionItemsMustBeClosed: 'Les éléments d\'action P3 doivent être fermés',
      p4ActionItemsMustBeClosed: 'Les éléments d\'action P4 doivent être fermés',
      onlyFinalApprovercanApprovePSSR: 'Seul l\'approbateur final peut approuver le PSSR',
      onlyPSSRTeamLeadClosePSSR: 'Seul le chef d\'équipe de PSSR peut fermer le PSSR',
    },
  },
  pdfDialog: {
    header: 'Joindre un fichier PDF',
    selectTypePrompt: 'Comment souhaitez-vous joindre ce PDF ?',
    document: 'Document',
    image: 'Image',
    selectPagesTitle: 'Sélectionnez les pages à convertir en images',
    allPages: 'Toutes les pages',
    selectPages: 'Sélectionner les pages',
    page: 'Page',
    select: 'Sélectionner',
    couldNotDetectPages: 'Impossible de détecter le nombre de pages. Toutes les pages seront incluses.',
  },
  attachmentUpload: {
    title: 'Joindre un Fichier',
    selectType: 'Que souhaitez-vous joindre?',
    types: {
      link: 'Lien',
      document: 'Document',
      image: 'Image',
    },
    forms: {
      url: 'URL',
      urlPlaceholder: 'https://exemple.com',
    },
    clickToSelect: 'Cliquez pour sélectionner un fichier',
    acceptedImageTypes: 'Formats acceptés: JPG, PNG, GIF, etc.',
    acceptedDocumentTypes: 'Formats acceptés: PDF, DOC, DOCX, XLS, XLSX',
    upload: 'Télécharger',
    successMessage: 'Fichier joint avec succès',
    sections: {
      images: 'Images',
      documents: 'Documents',
      links: 'Liens',
    },
    uploaded: 'Chargé le',
    download: 'Télécharger',
  },
  organizationsList: {
    title: 'Organisations',
    tableHeader: 'organisation',
    noOrganizations: 'Aucune organisation disponible',
    successCreated: 'Organisation créée avec succès',
    actions: {
      addNew: 'ajouter une nouvelle organisation',
    },
    forms: {
      name: 'Nom de l\'organisation',
      namePlaceholder: 'tapez un nom de l\'organisation',
    },
    dialogs: {
      addNew: 'Ajouter une nouvelle organisation',
      edit: 'Modifier l\'organisation',
      deleteHeader: 'Supprimer l\'organisation',
      deleteMessage: 'Êtes-vous sûr de vouloir supprimer l\'organisation : [{{name}}]?',
    },
  },
  userGroupsList: {
    title: 'Groupes d\'utilisateurs d\'éléments d\'action',
    groupsSection: 'Groupes',
    noUsers: 'Aucun utilisateur dans ce groupe',
    noGroups: 'Aucun groupe disponible',
    selectGroup: 'Sélectionner un groupe pour voir les utilisateurs',
    actions: {
      create: 'créer',
      addNewUser: 'ajouter un nouvel utilisateur',
      selectUser: 'Sélectionner l\'utilisateur',
      changeUser: 'Changer l\'utilisateur',
      add: 'Ajouter',
    },
    table: {
      userName: 'nom d\'utilisateur',
      email: 'email',
    },
    forms: {
      namePlaceholder: 'Entrez le nom du groupe',
      selectUserPrompt: 'Veuillez sélectionner un utilisateur à ajouter à ce groupe',
      selectedUser: 'Utilisateur sélectionné',
    },
    dialogs: {
      addGroup: 'Ajouter un nouveau groupe',
      editGroup: 'Modifier le groupe',
      deleteGroupHeader: 'Supprimer le groupe',
      deleteGroupMessage: 'Êtes-vous sûr de vouloir supprimer le groupe : [{{name}}]?',
      removeUserHeader: 'Supprimer l\'utilisateur',
      removeUserMessage: 'Êtes-vous sûr de vouloir supprimer {{name}} de ce groupe?',
      addUser: 'Ajouter un utilisateur au groupe',
      selectUser: 'Sélectionner l\'utilisateur',
    },
  },
  participants: {
    title: 'Participants',
    addParticipant: 'ajouter un participant',
    addMember: 'Ajouter un membre',
    pssrTeamLead: 'Chef d\'équipe {{pssrTitle}}',
    pssrTeam: 'Équipe {{pssrTitle}}',
    projectManagers: 'Chefs de Projet',
    projectTeamMembers: 'Membres de l\'Équipe du Projet',
    operationsRepresentative: 'Représentant des Opérations',
    finalApprover: 'Approbateur Final',
    actionItemAssignee: 'Assigné de l\'Élément d\'Action',
    noParticipantsAdded: 'Aucun participant ajouté',
    signedBy: 'signé par',
    signedInBehalfOf: 'signé au nom de',
    signedOn: 'signé le',
  },
  qaqcImport: {
    title: 'Import QAQC',
    milestone: 'Jalon QAQC',
    workOrders: 'Ordres de travail QAQC',
    milestoneWorkOrders: 'Ordres de travail du Jalon QAQC (optionnel)',
    milestoneWorkOrdersLabel: 'Ordres de travail du Jalon QAQC',
    milestoneWorkOrdersMessage: 'Sélectionnez 1 jalon pour voir les ordres de travail dans ce jalon',
    noItemsAvailable: 'Aucun jalon/ordre de travail disponible depuis QAQC',
    noWorkOrdersForMilestone: 'Aucun ordre de travail disponible pour ce jalon',
    unableLoadItems:
      'Impossible de joindre le système QAQC pour les jalons/ordres de travail, veuillez réessayer plus tard',
    loadEventsError: 'Erreur lors de l\'obtention de {{eventLabel}} depuis QAQC',
    multipleMilestonesWarning: 'Veuillez sélectionner 1 jalon pour voir les ordres de travail dans ce jalon',
    generatePssrTitle: 'Générer le titre PSSR',
    alreadyExists: 'Cet événement QAQC existe déjà en tant que projet',
    selectEvent: 'Projet',
    sections: 'Sections',
    assignSectionLeads: 'Attribuer des responsables de section',
    selectLead: 'Sélectionner un responsable',
    sectionName: 'Nom de Section',
    lead: 'Responsable',
    template: 'Modèle',
    type: 'Type',
    projectType: 'Type de Projet',
    successMessage: 'Import QAQC terminé. Projet et PSSRs créés.',
    errorMessage: 'Erreur lors de la création du projet QAQC. Veuillez réessayer.',
    projectCreatedWithoutItems:
      'Projet créé. QAQC n\'a pas encore de jalons ni d\'ordres de travail ; utilisez "Charger les nouveaux éléments QAQC" lorsqu\'ils seront disponibles.',
    partialErrorMessage:
      'Le projet a été créé, mais ses PSSRs n\'ont pas pu l\'être. Utilisez "Charger les nouveaux éléments QAQC" pour réessayer.',
    somePssrsNotCreated:
      'Seuls {{created}} PSSRs sur {{total}} ont été créés. Utilisez "Charger les nouveaux éléments QAQC" pour créer les autres.',
  },
  participantDialog: {
    title: 'Sélectionner un participant',
    addParticipant: 'Ajouter un Participant',
    selectUserType: 'Sélectionner le Type d\'Utilisateur',
    selectedUserType: 'Type d\'Utilisateur Sélectionné',
    chevronDirectory: 'répertoire chevron/utilisateurs partagés',
    newNonChevron: 'nouveau non-chevron',
    searchPlaceholder: 'Rechercher par email...',
    emailPlaceholder: 'Entrer l\'email...',
    namePlaceholder: 'Entrer le nom...',
    selectRole: 'Sélectionner un rôle',
    selectedRole: 'Rôle Sélectionné',
    selectOne: 'sélectionner un',
    add: 'ajouter',
    stagedParticipants: 'à ajouter :',
    batchLimitReached: 'limite de {{limit}} utilisateurs atteinte, veuillez sélectionner ajouter',
    alreadyStagedError: 'cet utilisateur est déjà dans la liste',
    successMessage: 'Participant ajouté avec succès',
    added: 'Participant ajouté avec succès',
    addError: 'Erreur lors de l\'ajout du participant',
    alreadyParticipantPssr: 'Cet utilisateur est déjà participant de ce PSSR en tant que {{role}}',
    alreadyMemberProject: 'Cet utilisateur est déjà membre de ce projet en tant que {{role}}',
  },
  participantEditDialog: {
    title: 'Modifier le participant',
    user: 'Utilisateur',
    selectRole: 'Sélectionner le rôle',
    delete: 'supprimer',
    captureSignature: 'capturer la signature',
    recaptureSignature: 're-capturer la signature',
    removeSignature: 'supprimer la signature',
    removeSignatureSuccess: 'Signature supprimée avec succès',
    save: 'enregistrer',
    noSignature: 'Aucune signature capturée',
    successMessage: 'Participant mis à jour avec succès',
    deleteSuccessMessage: 'Participant supprimé avec succès',
    deleteConfirmHeader: 'Supprimer le participant',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce participant ?',
  },
  buAdminsList: {
    title: 'Utilisateurs Administrateurs BU',
    actions: {
      addNewUser: 'ajouter un utilisateur administrateur',
      delete: 'supprimer',
    },
    table: {
      fullName: 'nom complet',
      email: 'email',
    },
    noAdmins: 'Aucun utilisateur administrateur disponible',
  },
  externalUserForm: {
    labels: {
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      userNameEmail: 'Nom utilisateur ou email',
    },
  },
  sharedUserForm: {
    labels: {
      sharedUserGroup: 'Groupe d\'utilisateurs partagés',
      sharedEmail: 'Email partagé',
    },
    actions: {
      addChildUser: 'ajouter un utilisateur',
      importSharedUsers: 'Importer des utilisateurs partagés',
    },
    whitePages: {
      title: 'Intégration des Pages Blanches',
      description:
        'Utilisez ce type d\'email partagé si vous devez synchroniser avec les Pages Blanches. La liste des utilisateurs sera mise à jour automatiquement au fil du temps. Certains utilisateurs peuvent être automatiquement ajoutés ou supprimés de cet email partagé.',
    },
    customConfiguration: {
      title: 'Configuration personnalisée',
      description: 'Gérez manuellement la liste des utilisateurs.',
    },
  },
  pssrsList: {
    title: 'PSSR',
    location: 'Localisation',
    details: 'Détails',
    emptyMessage: 'Aucun PSSR trouvé',

    searchByLocation: 'Localisation',
    searchByDetails: 'D\u00e9tails',
    filters: {
      businessUnit: 'Unit\u00e9 commerciale',
      organization: 'Organisation',
      area: 'Zone',
      subArea: 'Sous-zone',
      placeholderSubArea: 'S\u00e9lectionner Sous-zone',
      facilityOperationTeam: 'Équipe d\'opération de l\'installation',
      facility: 'Installation',
      placeholderFacility: 'S\u00e9lectionner Installation',
      project: 'Projet',
      placeholderProject: 'Sélectionner Projet',
      template: 'Mod\u00e8le',
      selectOne: 'en choisir un',
      status: 'Statut',
      type: 'Type',
      deletedStagnant: 'Supprim\u00e9/Stagnant',
      showOnlyDeleted: 'afficher seulement les pssrs supprimés',
      showOnlyStagnant: 'afficher seulement les pssrs stagnants',
      search: 'Recherche',
      placeholderSearch: 'rechercher par moc, wo, id de pssr, titre, etc...',
      userSearch: 'Recherche Utilisateur',
      placeholderUserSearch: 'sample text',
      isStagnant: 'Est Stagnant',
      isDeleted: 'Est Supprim\u00e9',
    },
    buttons: {
      clearFilter: 'filtre clair',
      newPssr: 'nouveau PSSR',
      viewItems: 'voir les \u00e9l\u00e9ments',
      open: 'ouvrir',
    },
    actions: {
      clearFilter: 'Effacer le filtre',
      newPssr: 'nouveau pssr',
      importPssr: 'Importer PSSRs',
    },
    table: {
      id: 'ID',
      title: 'Titre',
      type: 'Type',
      status: 'Statut',
      facility: 'Installation',
      project: 'Projet',
    },
    statusOptions: {
      draft: 'Brouillon',
      initiated: 'Initié',
      inProgress: 'En cours',
      completed: 'Complété',
      pendingApproval: 'Approbation en attente',
      approved: 'Approuvé',
      closed: 'Fermé',
    },
    noPssrs: 'Aucun PSSR disponible',
  },
  pssrListItem: {
    pssrId: 'ID D\'APPROVISIONNEMENT',
    pssr: 'PSSR',
    moc: 'MOC',
    wo: 'WO',
    project: 'Projet',
    teamLeads: 'Chefs d\'\u00e9quipe',
    totalQuestions: 'Questions totales',
    outstandingQuestions: 'Questions en cours',
    completedQuestions: 'Questions termin\u00e9es',
    area: 'Zone',
    subArea: 'Sous-zone',
    facility: 'Installation',
    qaqcStatus: 'Statut QAQC',
    qaqcMilestone: 'Jalon QAQC',
    qaqcWorkOrder: 'Ordre de travail QAQC',
    qaqcReady: '% prêt',
    qaqcComplete: '% terminé',
    qaqcAccepted: '% accepté',
    qaqcSignatures: 'Signatures',
    qaqcDocuments: 'Documents QAQC',
    qaqcNoData: 'Aucune donnée QAQC',
  },
  pssrStatuses: {
    Draft: 'Brouillon',
    Initiated: 'Initié',
    InProgress: 'En cours',
    Completed: 'Complété',
    PendingApproval: 'Approbation en attente',
    Approved: 'Approuvé',
    Closed: 'Fermé',
    Deleted: 'Supprimé',
    CreateDate: 'Brouillon Créé le',
    InitiatedOn: 'Initié le',
    StartedOn: 'Commencé',
    CompletedOn: 'Visite Complétée le',
    PendingApprovalOn: 'Approbation Soumise le',
    ApprovedOn: 'Approuvé le',
    ClosedOn: 'Fermé le',
    DeletedOn: 'Supprimé le',
    RestoredOn: 'Restauré le',
  },
  signatureCaptureDialog: {
    title: 'Capturer la Signature',
    confirm: 'confirmer',
    saveSuccess: 'Signature capturée avec succès',
  },
  projectsList: {
    title: 'Projets',
    table: {
      projectName: 'Nom du projet',
      projectManager: 'Chef de projet',
      status: 'Statut',
      completedTotalPssrs: 'Pssrs terminés/total',
      actions: 'Actions',
      dateCreated: 'Date de création',
    },
    statusLabels: {
      active: 'actif',
      closed: 'fermé',
    },
    sort: {
      placeholder: 'Trier par',
      nameAsc: 'Nom (A-Z)',
      nameDesc: 'Nom (Z-A)',
      statusAsc: 'Statut (Bas à Élevé)',
      statusDesc: 'Statut (Élevé à Bas)',
      dateAsc: 'Date de Création (Plus Ancien)',
      dateDesc: 'Date de Création (Plus Récent)',
    },
    actions: {
      open: 'ouvrir',
      createProject: 'créer un projet',
    },
    projectSearch: 'Recherche de projet',
    showDeletedProjects: 'Afficher les projets supprimés',
    searchPlaceholder: 'Rechercher par nom',
    datePlaceholder: 'mm/jj/aaaa - mm/jj/aaaa',
    statusPlaceholder: 'sélectionner un',
    noProjects: 'Aucun projet disponible',
  },
  projectEdit: {
    title: 'Modifier le Projet',
    projectName: 'Nom du Projet',
    projectNamePlaceholder: 'Entrez le nom du projet',
    statusActive: 'actif',
    statusClosed: 'fermé',
    statusDeleted: 'supprimé',
    teamMembers: 'Membres de l\'Équipe',
    addParticipant: 'ajouter un participant',
    pssrCcc: 'PSSR/CCC',
    newPssr: 'Nouveau {{pssrTitle}}',
    noPssrCcc: 'Il n\'y a pas de PSSR/CCC associés à ce projet.',
    delete: 'supprimer',
    markAsClosed: 'marquer comme fermé',
    reopen: 'rouvrir',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer ce projet?',
    confirmDeleteHeader: 'Confirmer la Suppression',
    confirmDeletePssrs: 'Voulez-vous également supprimer tous les PSSRs associés à ce projet?',
    confirmDeletePssrsHeader: 'Supprimer les PSSRs?',
    deleteSuccess: 'Projet supprimé avec succès',
    confirmMarkAsClosed: 'Êtes-vous sûr de vouloir marquer ce projet comme fermé?',
    confirmMarkAsClosedHeader: 'Confirmer Marquer comme Fermé',
    markedAsClosedSuccess: 'Projet marqué comme fermé avec succès',
    confirmCloseProjectTitle: 'Confirmer la Fermeture du Projet',
    confirmCloseProjectDescription: 'Êtes-vous sûr de vouloir marquer ce projet comme fermé?',
    confirmReopenProjectTitle: 'Confirmer la Réouverture du Projet',
    confirmReopenProjectDescription: 'Êtes-vous sûr de vouloir rouvrir ce projet?',
    cannotCloseProjectDueOpenPSSRs: 'Impossible de fermer le projet car il y a des PSSRs ouverts.',
    projectUpdatedSuccessfully: 'Projet mis à jour avec succès',
    loadNewQaqcItems: 'Charger les nouveaux éléments QAQC',
    qaqcItemsLoadedSuccessfully: 'Les nouveaux éléments QAQC ont été chargés avec succès',
    qaqcItemsUpToDate: 'Les éléments QAQC sont déjà à jour',
    qaqcInputWarning: 'Veuillez compléter les champs QAQC requis avant de charger de nouveaux éléments : {{fields}}.',
    initiateAll: 'Initier tous les PSSR',
    initiateAllTitle: 'Initier tous les PSSR',
    initiateAllDescription: 'Voulez-vous initier tous les PSSR de ce projet ?',
    initiateAllSuccess: 'Tous les PSSR ont été initiés avec succès',
    initiateAllPartialError: 'Certains PSSR n\'ont pas pu être initiés :',
    projectReopenedSuccessfully: 'Projet rouvert avec succès',
    restorePssr: 'Restaurer',
    confirmRestoreProject: 'Êtes-vous sûr de vouloir restaurer ce projet?',
    confirmRestoreProjectHeader: 'Confirmer la Restauration',
    restoreSuccess: 'Projet restauré avec succès',
    deleteDialog: {
      cascade: 'cascade',
      title: 'Confirmer la suppression du projet',
      confirmDeleteWithPssrs:
        'L\'action suivante pourrait supprimer le projet et les PSSR impliqués. Souhaitez-vous continuer?',
      confirmDeleteWithoutPssrs: 'Souhaitez-vous continuer?',
      deleteProjectAndPssrs: 'Supprimer le Projet et les PSSRs',
      deleteProjectOnly: 'Supprimer Uniquement le Projet',
      deleteSuccess: 'Projet supprimé avec succès',
      deleteError: 'Erreur lors de la suppression du projet',
    },
    cascadeDialog: {
      cascade: 'cascade',
      title: 'Rôles en Cascade',
      description:
        'Sélectionnez les participants que vous souhaitez appliquer en cascade à tous les PSSRs de ce projet.',
      teamLeads: 'Chefs d\'Équipe',
      teamMembers: 'Membres de l\'Équipe',
      operationsRepresentative: 'Représentant des Opérations',
      finalApprover: 'Approbateur Final',
      apply: 'appliquer',
      success: 'Rôles appliqués en cascade avec succès',
    },
    errors: {
      noPermissionToEditParticipants: 'Vous n\'avez pas la permission de modifier les participants de ce projet',
    },
  },
  multiselect: {
    selectedItems: '{0} éléments sélectionnés',
    placeholder: 'choisir',
  },
  support: {
    title: 'Retour d\'information',
    buSupportInfo: 'Informations de Support BU ePSSR',
    serviceNowInstructions: 'Instructions de Billetterie ePSSR Service Now',
    instructions: {
      step1:
        'Accédez au formulaire de <a class="support-link" href="https://chevron.service-now.com/mychevron?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981&sysparm_u_appid=1500000886" target="_blank" rel="noopener">Demande de Support d\'Application</a> dans le Portail de Services IT de Chevron',
      step1LinkText: 'Demande de Support d\'Application',
      step2: 'Dans le champ Application, sélectionnez <b>Mobile PSSR</b>.',
      step3:
        'Pour signaler un problème ou un bug, veuillez sélectionner <b>Signaler un Problème</b>. Pour soumettre une demande d\'amélioration ou d\'accès utilisateur, sélectionnez <b>Demande de Service</b>. Cliquez sur Suivant.',
    },
    reportIssue: {
      title: 'Signaler un Problème',
      step1: 'Remplissez la Description du Problème, l\'Impact et l\'Urgence.',
      step2: 'Appuyez sur Suivant puis Soumettre.',
      step3: 'L\'équipe de Support ePSSR accusera réception du ticket dans les 24 heures pendant les heures ouvrables.',
    },
    enhancement: {
      title: 'Demande d\'Amélioration',
      step1: 'Veuillez sélectionner <b>Améliorations</b> dans Type de Demandes.',
      step2: 'Sélectionnez la Priorité (<b>Faible, Modérée, Élevée</b>)',
      step3: 'Remplissez la Description de la Demande',
      step4: 'Sélectionnez Suivant et Soumettre.',
      step5:
        'L\'équipe de Support ePSSR examinera les demandes d\'amélioration dans le cadre du Processus de Planification PI de Surface Digital',
    },
    userAccess: {
      title: 'Demande d\'Accès Utilisateur',
      step1: 'Veuillez sélectionner <b>Demander l\'Accès</b> dans Type de Demandes.',
      step2: 'Sélectionnez le Type de Demande d\'Accès (<b>Ajouter ou Supprimer</b>)',
      step3: 'Sélectionnez un utilisateur',
      step4: 'Sélectionnez la Priorité (<b>Faible, Modérée, Élevée</b>)',
      step5: 'Spécifiez le Rôle et l\'Accès dont l\'utilisateur a besoin.',
      step6: 'Sélectionnez Suivant et Soumettre.',
      step7: 'L\'équipe de Support ePSSR accusera réception du ticket dans les 24 heures pendant les heures ouvrables.',
    },
  },
  datepicker: {
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    monthNames: [
      'Janvier',
      'Février',
      'Mars',
      'Avril',
      'Mai',
      'Juin',
      'Juillet',
      'Août',
      'Septembre',
      'Octobre',
      'Novembre',
      'Décembre',
    ],
    monthNamesShort: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'],
    today: 'Aujourd\'hui',
    clear: 'Effacer',
    dateFormat: 'mm/dd/yy',
    weekHeader: 'Sm',
  },
  errors: {
    unauthorized: {
      title: 'Accès non autorisé',
      message: 'Vous n\'avez pas la permission d\'accéder à cette page.',
    },
    serverError: {
      title: 'Erreur du serveur',
      message: 'Une erreur inattendue s\'est produite. Veuillez réessayer plus tard.',
    },
    pageNotFound: {
      title: 'Page introuvable',
      message: 'La page que vous recherchez n\'existe pas.',
    },
    actions: {
      returnHome: 'Retour à l\'accueil',
    },
  },
  attachments: {
    sections: {
      images: 'Images',
      documents: 'Documents',
      links: 'Liens',
    },
    actions: {
      download: 'Télécharger',
      delete: 'Supprimer',
    },
    labels: {
      uploaded: 'Téléversé',
    },
  },
  imagePreview: {
    errorMessage: 'Échec du chargement de l\'image',
    errorDetails: 'Vérifiez la console du navigateur pour plus de détails',
  },
  functionalReview: {
    audit: {
      createdBy: 'Créé par',
      updatedDate: 'Date de mise à jour',
      updatedBy: 'Mis à jour par',
    },
  },
  checklistItem: {
    toolbar: {
      bold: 'Gras',
      italic: 'Italique',
      underline: 'Souligné',
      orderedList: 'Liste ordonnée',
      unorderedList: 'Liste non ordonnée',
      codeBlock: 'Bloc de code',
      blockQuote: 'Bloc de citation',
    },
    alignment: {
      center: 'centré',
      right: 'droite',
      justify: 'justifié',
    },
  },
  pssrSections: {
    actions: {
      removeUser: 'Supprimer l\'utilisateur',
    },
  },
  pssrParticipantsSections: {
    actions: {
      remove: 'Supprimer',
    },
  },
  progressBar: {
    label: 'Progression :',
  },
  categories: {
    dialogs: {
      addCategory: 'Ajouter une catégorie',
      editCategory: 'Modifier la catégorie',
      createSubCategory: 'Créer une nouvelle sous-catégorie',
      editSubCategory: 'Modifier la sous-catégorie',
    },
    placeholders: {
      subcategoryName: 'Nom de la sous-catégorie',
    },
  },
  categoriesList: {
    title: 'Catégories',
    hideInactiveItems: 'Masquer les éléments inactifs',
    subCategoryName: 'Nom de la sous-catégorie',
    inactive: '(inactif)',
    noSubcategories: 'Aucune sous-catégorie',
    selectHeader: 'Sélectionner',
    actions: {
      createSubCategory: 'Créer une nouvelle sous-catégorie',
      restore: 'Restaurer',
      add: 'Ajouter',
      addSubCategories: 'Ajouter des sous-catégories',
      remove: 'Retirer',
    },
    deleteDisabledTooltip: 'Cette catégorie ne peut pas être supprimée car elle contient des sous-catégories actives',
    dialogs: {
      addSubCategoriesHeader: 'Ajouter des sous-catégories',
      deleteCategoryHeader: 'Attention',
      deleteCategoryMessage: 'Êtes-vous sûr de vouloir supprimer la Catégorie : [{{name}}] ?',
      deleteSubCategoryHeader: 'Attention',
      deleteSubCategoryMessage: 'Retirer [{{name}}] de la catégorie [{{category}}] ? La sous-catégorie elle-même ne sera pas supprimée.',
    },
    validation: {
      subCategoryExists: 'Une sous-catégorie portant ce nom existe déjà',
      categoryExists: 'Une catégorie portant ce nom existe déjà',
    },
  },
};
export default fr;
